import $ from "jquery/dist/jquery";

$(() => {
  const cm = $("#add-watchdog-email-modal");
  const modal_watchdog_ok = $("#add-watchdog-modal-ok");

  function callWatchdog(url, parent) {
    $.ajax({
      url: url,
      method: "POST",
    }).done((data) => {
      parent.html(data.body);
    });
  }

  $(".eshop-item-watchdog").on("click", ".eshop-item-watchdog-deactivate-btn", function (e) {
    e.preventDefault();
    const btn = $(this);
    callWatchdog(btn.prop("href"), btn.closest(".eshop-item-watchdog"));
    return false;
  });

  $(".eshop-item-watchdog").on("click", ".eshop-item-watchdog-activate-btn", function (e) {
    e.preventDefault();

    const btn = $(this);
    if (btn.data("user-logged") === true) {
      // user is logged, do it now
      callWatchdog(btn.prop("href"), btn.closest(".eshop-item-watchdog"));
    } else {
      // display modal asking for e-mail
      window.NXCMS.modal(cm, true);
    }
    return false;
  });

  $("#add-watchdog-email-modal form").submit((e) => {
    e.preventDefault();
    const f = $(e.target);
    $.ajax({
      url: f.attr("action"),
      method: f.attr("method"),
      data: f.serialize(),
    }).done((data) => {
      f[0].reset();
      $(".eshop-item-watchdog").html(data.body);

      window.NXCMS.modal(cm, false);
      window.NXCMS.modal(modal_watchdog_ok, true);
    });
    return false;
  });
});
